// PositionsTradePopup.jsx — Trade popup for the Positions page
// Shows position details with "Add More" and "Square Off" buttons
// Built with Tailwind CSS
//
// "Add More" → tells parent to open OrderPopup in addMore mode (1 lot, LTP, margin display)
// "Square Off" → tells parent to open OrderPopup in squareOff mode (position qty, LTP, premium to pay)

import React from 'react';
import { fmtINR } from './calculations';

function PositionsTradePopup({ row, isDark, onClose, onAddMore, onSquareOff }) {
  if (!row) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50" onClick={onClose}>
      <div className={`rounded-lg w-96 shadow-2xl ${isDark ? 'bg-app-card border border-app-border' : 'bg-white border border-gray-200'}`} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className={`px-4 py-3 flex justify-between items-center border-b ${isDark ? 'border-app-border' : 'border-gray-200'}`}>
          <div>
            <span className="font-bold text-sm">{row.symbol}</span>
            <span className={`ml-2 text-xs ${isDark ? 'text-app-text-muted' : 'text-gray-500'}`}>{row.strike} {row.type}</span>
            <span className={`ml-2 text-[11px] ${isDark ? 'text-app-text-dim' : 'text-gray-400'}`}>{row.expiryStr}</span>
          </div>
          <button onClick={onClose} className={`text-lg border-none bg-transparent cursor-pointer ${isDark ? 'text-app-text-muted' : 'text-gray-400'}`}>✕</button>
        </div>

        {/* Position Info */}
        <div className={`px-4 py-3 text-xs space-y-2 border-b ${isDark ? 'border-app-border' : 'border-gray-200'}`}>
          <div className="flex justify-between">
            <span className={isDark ? 'text-app-text-muted' : 'text-gray-500'}>Account</span>
            <span className="font-medium">{row.accountLabel}</span>
          </div>
          <div className="flex justify-between">
            <span className={isDark ? 'text-app-text-muted' : 'text-gray-500'}>Direction</span>
            <span className={`font-semibold ${row.isSold ? 'text-accent-red' : 'text-accent-green'}`}>{row.buyOrSell}</span>
          </div>
          <div className="flex justify-between">
            <span className={isDark ? 'text-app-text-muted' : 'text-gray-500'}>Lots</span>
            <span className="font-medium">{row.lots} ({row.lots * row.lotSize} qty)</span>
          </div>
          <div className="flex justify-between">
            <span className={isDark ? 'text-app-text-muted' : 'text-gray-500'}>Avg Price</span>
            <span>₹{Number(row.avgPrice).toFixed(2)}</span>
          </div>
          <div className="flex justify-between">
            <span className={isDark ? 'text-app-text-muted' : 'text-gray-500'}>LTP</span>
            <span className="font-semibold">{row.ltp > 0 ? `₹${Number(row.ltp).toFixed(2)}` : '—'}</span>
          </div>
          <div className="flex justify-between">
            <span className={isDark ? 'text-app-text-muted' : 'text-gray-500'}>Profit</span>
            <span className={`font-semibold ${row.profit > 0 ? 'text-accent-green' : row.profit < 0 ? 'text-accent-red' : ''}`}>{row.profit !== 0 ? fmtINR(row.profit) : '—'}</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="px-4 py-3 flex gap-3">
          <button
            onClick={() => { onClose(); onAddMore(row); }}
            className="flex-1 py-2 text-xs font-bold rounded text-white bg-accent-green border-none cursor-pointer hover:opacity-90"
          >
            Add More
          </button>
          <button
            onClick={() => { onClose(); onSquareOff(row); }}
            className="flex-1 py-2 text-xs font-bold rounded text-white bg-accent-red border-none cursor-pointer hover:opacity-90"
          >
            Square Off
          </button>
        </div>
      </div>
    </div>
  );
}

export default PositionsTradePopup;
